import React from 'react';
import { Collapse, Typography } from 'antd';
import { OPEN_API_DOC_TITLES } from '@utils/api-doc-constants/openApi-constant';
import "./apiDoc.css"
// @ts-ignore
import { markettingWebUrl } from '../../environment/environment';

const { Panel } = Collapse;
const { Text } = Typography;

const OpenApiSection = () => {
  const ApiDocTitlesData = OPEN_API_DOC_TITLES
  const renderNestedPanel = (children: any) => (
    <Collapse>
      {children.map((child: any, index: any) => (
        <Panel header={child.question} key={`child-${index}`}>
          <Text>{child.answer}</Text>
        </Panel>
      ))}
    </Collapse>
  );

  const features = [
    "Create referrers automatically",
    "Send referral invitations with rewards",
    "Track referral status lifecycle",
    "Fetch available rewards",
    "Pay referrals and referrers",
    "Fully automate referral-to-payment workflows using Zapier",
  ];

  return (
    <div style={{ padding: '0px 0px' }}>
      <div className="docHeading">
        <h1>Open API Documentation</h1>
      </div>

      <div className="doc-intro">
        <p>
          Welcome to <strong><a href={markettingWebUrl} target='blank' className='doc-link'
          >ReferUs</a></strong> — a referral automation platform that lets businesses
          create referrers, send referrals, manage rewards, and automate payouts using APIs.
        </p>

        <p>This documentation is designed for:</p>

        <ul>
          <li>Third-party developers integrating directly via APIs</li>
          <li>Zapier users consuming ReferUs actions</li>
          <li>Partners building no-code / low-code referral workflows</li>
        </ul>

        <h2>What You Can Build with ReferUs</h2>

        <ul>
          {features.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </div>

      <Collapse accordion>
        {ApiDocTitlesData.map((title, index) => (
          <Panel header={title.question} key={index}>
            <Text>{title.answer}</Text>
            {title.children && renderNestedPanel(title.children)}
          </Panel>
        ))}
      </Collapse>
    </div>
  );
};

export default OpenApiSection;
